import React, { Component } from 'react';

class FilterBox extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selected: []
		};

		this.testate = [
			{name: "Agenda", bucketName: "agendadigitalewp"},
			{name: "Digital4", bucketName: "digital4wp"},
			{name: "Digital4Trade", bucketName: "digital4trade"},
			{name: "Economy Up", bucketName: "economyupwp"},
			{name: "CorCom", bucketName: "corcomwp"},
			{name: "Cybersecurity", bucketName: "cybersecurity360"},
			{name: "Industry4Business", bucketName: "industry4business"},
			{name: "Multisitetestate", bucketName: "multisitetestate"},
			{name: "Internet4things", bucketName: "internet4things"},
			{name: "University4Business", bucketName: "university2business"},
			{name: "StartupBusiness", bucketName: "wpstartupbusiness"},
			{name: "Zerouno", bucketName: "zerounowebwp"},
		];

		this.createCheckboxes = this.createCheckboxes.bind(this);
		this.updateFilter = this.updateFilter.bind(this);
	}

	updateFilter(event) {
		let selectedCheckboxes = this.state.selected;
		if(event.target.checked) {
			selectedCheckboxes.push(event.target.value);
		} else {
			selectedCheckboxes = selectedCheckboxes.filter((item) => { return item !== event.target.value });
		}
		this.setState({
			selected: selectedCheckboxes
		}, () => {
			this.props.updateView(this.state.selected);
		});
	}

	createCheckboxes() {
		return this.testate.map((testata) => {
			return (
				<div className="field" key={testata.bucketName}>
				<input onChange={this.updateFilter} className="is-checkradio"  id={testata.name} type="checkbox" value={testata.bucketName}/>
				<label htmlFor={testata.name} className="checkbox">{ testata.name }</label>
				</div>
			)
		});
	}

	render() {
		return (
			<div className="box has-text-left">
			<p className="title is-4 has-text-left">Filtri</p>
			{ this.createCheckboxes() }
			</div>
		);		
	}
}

export default FilterBox


// WEBPACK FOOTER //
// ./src/components/filter-box.jsx